import React, {Component} from 'react'
import trans from "trans"
import { connect } from "react-redux"
import { AxiosResponse } from 'axios'

import {
    css,
    Grid,
    GridCell,
    Button,
    Theme,
    Spinner,
    Icon,
    InputGroup,
} from "@bdfx/mergado-ui-kit"

import {URL} from "app/config/api-config";
import {getGradients, getInvertMaskObjects, getTemplate, projectId, saveInvertMaskObjects} from "app/helpers/api";
import Mergado from "app/helpers/mergado"
import {isJson} from "app/helpers/other";

import {
    availableQualityOptionsMistakeByUser,
    availableValidationOptionsMistakeByUser,
    ImagePreviewWrapper,
    ImgModeType,
    SetByUser,
} from "./product-table";

import {DarkGrayColor} from "app/helpers/colors";
import {LEFT_ARROW_KEY, RIGHT_ARROW_KEY} from "app/helpers/keymap";
import WatermarksMarker from "./watermarks-marker";
import InvertMaskMarker, { InvertMaskModeType } from './invert-mask-marker';
import { ObjectsType } from './watermark-marker-common'
import {ExtendedProductType, RENDERED_TYPE_AUTOWMREMOVE, RENDERED_TYPE_BGREMOVE} from "../types";
import { find } from 'lodash';
import { AlternativeTemplatesLevels, Gradient, SettingsFormType, Template } from 'app/types/model-types';
import { selectFormValues } from 'app/reducers/form'
import { setGradientsToStore } from 'template-edit/reducers'
import { addClass, hasClass, removeClass } from 'shape-edit/forms/helpers'

export interface Props {
    alternativeTemplatesLevels: AlternativeTemplatesLevels[]
    data: ExtendedProductType
    viewTable: string
    imgMode: ImgModeType
    isTheLast: boolean
    isTheFirst: boolean
    idx: number
    altLevel: number
    editMode?: boolean
    changeSetByUser: Function
    closeModal: Function
    updateModal: Function
    updateWatermarkMasksFromDb: Function
    userId: number
    settingsForm: SettingsFormType
    gradients: Gradient[]
    setGradientsToStore: typeof setGradientsToStore
}

type InvertMaskType = {
    userSetObjects: string
    maskHash: string
    maskMode: InvertMaskModeType
    isSourceByTypeExists: boolean
}

interface State {
    currentAltLevel: number
    template: Template
    invertMask: InvertMaskType
    editMode: boolean
}

const MERGADO_APP = 'https://app.mergado.com/projects/'+projectId+'/product'


class ProductModalWrapper extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            currentAltLevel: props.altLevel,
            template: null,
            invertMask: null,
            editMode: !!props.editMode,
        }
    }

    getTemplateType = () => {
        const { data, viewTable } = this.props
        return viewTable === 'products' && data?.template?.type ? data.template.type : null
    }

    //manual edit for some template types (like in previews), main image only:
    canRemoveWatermark = () => {
        const { data } = this.props
        return this.getTemplateType() === RENDERED_TYPE_AUTOWMREMOVE && typeof this.state.currentAltLevel !== 'number' &&
            !!(data.image_hash && data.image_width && data.image_height)
    }

    canRemoveBackground = () => {
        const { data } = this.props
        const { template, invertMask } = this.state
        return this.getTemplateType() === RENDERED_TYPE_BGREMOVE && typeof this.state.currentAltLevel !== 'number' &&
            !!(data.image_hash && data.image_width && data.image_height) &&
            !!template && !!invertMask?.isSourceByTypeExists
    }

    //editor is shown only after clicking the edit button
    isRemoveWatermark = () => this.state.editMode && this.canRemoveWatermark()

    isRemoveBackground = () => this.state.editMode && this.canRemoveBackground()

    loadInvertMaskData = () => {
        const { data } = this.props

        if (this.getTemplateType() !== RENDERED_TYPE_BGREMOVE || !data.image_id || !data.template_id) {
            return
        }

        getGradients()
            .then((response: AxiosResponse<Gradient[]>) => {
                this.props.setGradientsToStore(response.data)
            })
            .catch(error => {
                console.error('cannot set gradients', error)
            })

        getTemplate(data.template_id)
            .then((response: AxiosResponse<Template>) => {
                this.setState({ template: response.data })
            })
            .catch(error => {
                console.error(`cannot get template ${data.template_id}`, error)
            })

        getInvertMaskObjects(data.image_id, data.template_id)
            .then((response: AxiosResponse<InvertMaskType>) => {
                this.setState({
                    invertMask: {
                        userSetObjects: response.data.userSetObjects,
                        maskHash: response.data.maskHash,
                        maskMode: response.data.maskMode,
                        isSourceByTypeExists: response.data.isSourceByTypeExists,
                    }
                })
            })
            .catch(error => {
                console.error('cannot get invert mask objects', error)
            })
    }

    updateModalClass = () => {
        const elements = document.getElementsByClassName('react-confirm-alert-overlay')
        const el = elements[0] ?? null
        if (el) {
            const showInvertMaskMarker = this.isRemoveBackground()
            const showWatermarkMarker = this.isRemoveWatermark()

            if (showInvertMaskMarker && !hasClass(el, 'bgremove-modal')) {
                addClass(el, 'bgremove-modal')
            } else if (!showInvertMaskMarker && hasClass(el, 'bgremove-modal')) {
                removeClass(el, 'bgremove-modal')
            }

            if (showWatermarkMarker && !hasClass(el, 'wmremove-modal')) {
                addClass(el, 'wmremove-modal')
            } else if (!showWatermarkMarker && hasClass(el, 'wmremove-modal')) {
                removeClass(el, 'wmremove-modal')
            }
        }
    }

    handleKeyDown = (event) => {
        const { isTheFirst, isTheLast } = this.props

        //arrows are used by the marker
        if (this.isRemoveWatermark() || this.isRemoveBackground()) {
            return;
        }

        if (event.target.type || event.ctrlKey || (event.target.tagName && event.target.tagName === 'INPUT')) {
            return;
        }

        switch (event.keyCode) {
            case LEFT_ARROW_KEY:
                event.preventDefault()
                if (!isTheFirst) {
                    this.props.updateModal(-1)
                }
                break
            case RIGHT_ARROW_KEY:
                event.preventDefault()
                if (!isTheLast) {
                    this.props.updateModal(1)
                }
                break
        }
    }

    componentDidMount(): void {
        const { viewTable } = this.props

        if (viewTable !== 'watermarks') {
            document.addEventListener("keydown", this.handleKeyDown)
        }

        this.loadInvertMaskData()
        this.updateModalClass()
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown)
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps && prevProps.viewTable !== this.props.viewTable) {
            if (this.props.viewTable === 'watermarks') {
                document.removeEventListener("keydown", this.handleKeyDown)
            } else {
                document.addEventListener("keydown", this.handleKeyDown)
            }
        }

        if (prevState.currentAltLevel !== this.state.currentAltLevel || prevState.template !== this.state.template || prevState.invertMask !== this.state.invertMask || prevState.editMode !== this.state.editMode) {
            this.updateModalClass()
        }
    }

    render() {
        const { data, viewTable, idx, isTheFirst, isTheLast, imgMode, alternativeTemplatesLevels, gradients } = this.props
        const { currentAltLevel, template, invertMask } = this.state

        if (!data) {
            return <div><Spinner type={'bubbles'} /></div>
        }

        const productName = data.elements_name || ''
        const itemId = data.elements_item_id || ''
        const productId = data.product_id
        const productUrl = data.elements_url
        const mergadoProductUrl = `${MERGADO_APP}/${data.product_id}`
        const previewUrl = `${URL.laravelBase}images?template_id=${data.template_id}&product_id=${productId}&nocache=1`

        const name = productName && isJson(productName) ? JSON.parse(productName) : null
        const item_id = itemId && isJson(itemId) ? JSON.parse(itemId) : null

        const firstName = name && name[0].name ? name[0].name : ''
        const firstItemId = item_id && item_id[0] ? item_id[0].item_id : ''

        const options = viewTable === 'validations' ? availableValidationOptionsMistakeByUser :
            (viewTable === 'images_quality' ? availableQualityOptionsMistakeByUser : null)

        const navIconSize = 60

        let userSetValue: SetByUser = null
        let imageValidated: boolean = null
        switch (viewTable) {
            case 'validations':
                userSetValue = data.validations_mistake_set_by_user
                imageValidated = data.validations_status !== null
                break;
            case 'watermarks':
                userSetValue = data.watermarks_user_set
                imageValidated = data.watermarks_status !== null
                break;
            case 'images_quality':
                userSetValue = data.quality_user_set
                imageValidated = data.quality_status !== null
                break;
        }

        const isAlt = typeof currentAltLevel === 'number'

        const currentAltImage = isAlt ? data.alternative_images[currentAltLevel] : null

        const altLevelsForThisTemplate: AlternativeTemplatesLevels = alternativeTemplatesLevels && alternativeTemplatesLevels.length > 0 && data.template_id ?
            find(alternativeTemplatesLevels, (atl) => `${atl.template_id}` === `${data.template_id}` && !atl.levels || (atl?.levels && atl.levels.split(',').includes(`${currentAltLevel}`))) :
            null

        const imageOrAltObjects = isAlt ? currentAltImage?.alt_watermark_masks?.user_set_objects : data.masks_user_set_objects
        const imageOrAltMaskHash = isAlt ? currentAltImage?.alt_watermark_masks?.mask_hash : data.masks_mask_hash
        const imageOrAltUrl = isAlt ?
            (imgMode === 'fie' && altLevelsForThisTemplate ? `${URL.laravelBase}alt-images?alt_template_id=${altLevelsForThisTemplate.alternative_template_id}&product_id=${productId}&level=${currentAltImage?.level}&nocache=0` : currentAltImage?.url) :
            (imgMode === 'fie' ? `${URL.laravelBase}images?template_id=${data.template_id}&product_id=${productId}&nocache=0` : data.image_url)

        const imageOrAltWidth = isAlt ? currentAltImage?.width : data.image_width
        const imageOrAltHeight = isAlt ? currentAltImage?.height : data.image_height
        const imageOrAltHash = isAlt ? currentAltImage?.hash : data.image_hash
        const imageOrAltUrlHash = isAlt ? currentAltImage?.url_hash : data.image_url_hash
        const imageOrAltId = isAlt ? `${currentAltImage?.id}` : `${data.image_id}`

        const isRemoveWatermark = this.isRemoveWatermark()
        const isRemoveBackground = this.isRemoveBackground()
        const canEdit = this.canRemoveWatermark() || this.canRemoveBackground()

        const templateGradient = template?.gradient_id && gradients ? find(gradients, (g: Gradient) => {
            return `${g.id}` === `${template.gradient_id}`
        }) : null

        return (
            <ImagePreviewWrapper className={'pmwr'}>
                <StyledModalGrid cols={`50px auto ${(data.alternative_images.length > 1 ? '80px' : '')} 50px`}>
                    <GridCell col={'1/-1'} className={'title'}>
                        {viewTable !== 'watermarks' && (firstName || productName)}
                    </GridCell>

                    <GridCell className={'prev-link'}>
                        {!isTheFirst &&
                            <Button
                                type={'void'}
                                secondary={true}
                                color={Theme.blue}
                                onClick={() => this.props.updateModal(-1)}>
                                {idx < 1 ?
                                    <Icon type={'angle-double-left'} size={navIconSize} color={Theme.blue} /> :
                                    <Icon type={'angle-left'} size={navIconSize} />
                                }
                            </Button>
                        }
                    </GridCell>

                    <GridCell style={{ alignSelf: 'center' }}>
                        <Grid cols={'auto'} className={`${isRemoveWatermark || isRemoveBackground ? '' : (viewTable === 'products' ? 'small-div' : (viewTable === 'watermarks' ? '' : 'big-div'))}`}>
                            <GridCell style={{ alignSelf: 'center', justifyContent: "stretch" }}>
                                {isRemoveWatermark ?
                                    <WatermarksMarker
                                        productId={data.product_id}
                                        isAlt={false}
                                        imageOrAltImageId={data.image_id}
                                        imageOrAltImageHash={data.image_hash}
                                        imageOrAltImageObjects={data.masks_user_set_objects}
                                        imageOrAltImageUrl={data.image_url}
                                        imageOrAltImageUrlHash={data.image_url_hash}
                                        imageOrAltImageWidth={data.image_width}
                                        imageOrAltImageHeight={data.image_height}
                                        imageOrAltImageMaskHash={data.masks_mask_hash}
                                        updateWatermarkMasks={this.props.updateWatermarkMasksFromDb}
                                        setByUser={data.watermarks_user_set}
                                        changeSetByUser={this.props.changeSetByUser}
                                        closeModal={this.props.closeModal}
                                        idx={idx}
                                        altLevel={null}
                                        showClose={false}
                                    /> : isRemoveBackground ?
                                    <InvertMaskMarker
                                        product_id={data.product_id}
                                        image_id={data.image_id}
                                        form={{
                                            ...template,
                                            gradient: templateGradient
                                        }}
                                        isAlt={false}
                                        image_hash={data.image_hash}
                                        image_url={data.image_url}
                                        image_url_hash={data.image_url_hash}
                                        image_width={data.image_width}
                                        image_height={data.image_height}
                                        invert_user_set_objects={invertMask.userSetObjects}
                                        invert_mask_hash={invertMask.maskHash}
                                        invert_mask_mode={invertMask.maskMode}
                                        saveObjects={(objects: ObjectsType, mode: InvertMaskModeType) => {
                                            saveInvertMaskObjects(data.image_id, data.image_hash, objects, mode, data.image_width, data.image_height, false)
                                                .then((response: AxiosResponse<any>) => {
                                                    this.setState({
                                                        invertMask: {
                                                            ...invertMask,
                                                            userSetObjects: response.data?.userSetObjects,
                                                            maskHash: response.data?.maskHash,
                                                            maskMode: response.data?.maskMode,
                                                        }
                                                    })
                                                    this.props.updateWatermarkMasksFromDb()
                                                })
                                                .catch((e) => {
                                                    console.error('cannot save invert mask', e)
                                                })
                                        }}
                                        closeModal={this.props.closeModal}
                                        idx={idx}
                                        settingsForm={this.props.settingsForm}
                                    /> : viewTable === 'watermarks' && imgMode !== 'fie' ?
                                    <WatermarksMarker
                                        productId={data.product_id}
                                        isAlt={isAlt}
                                        imageOrAltImageId={imageOrAltId}
                                        imageOrAltImageHash={imageOrAltHash}
                                        imageOrAltImageObjects={imageOrAltObjects}
                                        imageOrAltImageUrl={imageOrAltUrl}
                                        imageOrAltImageUrlHash={imageOrAltUrlHash}
                                        imageOrAltImageWidth={imageOrAltWidth}
                                        imageOrAltImageHeight={imageOrAltHeight}
                                        imageOrAltImageMaskHash={imageOrAltMaskHash}
                                        updateWatermarkMasks={this.props.updateWatermarkMasksFromDb}
                                        setByUser={data.watermarks_user_set}
                                        changeSetByUser={this.props.changeSetByUser}
                                        closeModal={this.props.closeModal}
                                        idx={idx}
                                        altLevel={currentAltLevel}
                                        showClose={true}
                                    /> :
                                    <div>
                                        {imageOrAltUrl &&
                                            <img
                                                src={imageOrAltUrl}
                                                onClick={() => Mergado.openWindow(imageOrAltUrl)}
                                                title={!isAlt ? trans('main_image') : trans('alt_image') + ' ' + currentAltLevel}
                                            />
                                        }

                                        <div style={{ position: "relative", bottom: 0, fontSize: '10px', color: '#000' }}>
                                            {!isAlt ? trans('main_image') : trans('alt_image') + ' ' + currentAltLevel}
                                        </div>
                                    </div>
                                }
                            </GridCell>
                        </Grid>

                        {this.props.changeSetByUser && options && imageValidated && !isAlt &&
                            <InputGroup
                                singleChoice={true}
                                hideInput={true}
                                value={userSetValue}
                                onChange={(value) => {
                                    this.props.changeSetByUser(data.image_id, idx, value === 'null' ? null : value)
                                }}
                                items={options}
                            />
                        }
                    </GridCell>

                    {viewTable === 'products' && data.alternative_images.length > 1 &&
                        <GridCell className={'alt-images'}>
                            <Grid cols="60px" gap={'5px'}>
                                {data.image_link &&
                                    <GridCell
                                        className={`alt-images-gridcell ${!isAlt ? 'alt-image-active' : ''}`}
                                        onClick={() => this.setState({ currentAltLevel: null, editMode: false })}>
                                        <img src={imgMode === 'fie' ? `${URL.laravelBase}images?template_id=${data.template_id}&product_id=${productId}&nocache=0`: data.image_link} width="60" />
                                    </GridCell>
                                }
                                {data.alternative_images.map((a, altIdx) => {
                                    const altLevelsForThisTemplate: AlternativeTemplatesLevels = alternativeTemplatesLevels && alternativeTemplatesLevels.length > 0 && data.template_id ?
                                        find(alternativeTemplatesLevels, (atl) => `${atl.template_id}` === `${data.template_id}` && !atl.levels || (atl?.levels && atl.levels.split(',').includes(`${a.level}`))) :
                                        null
                                    return <GridCell
                                        className={`alt-images-gridcell ${altIdx === currentAltLevel ? 'alt-image-active' : ''}`}
                                        onClick={() => this.setState({ currentAltLevel: altIdx, editMode: false })}
                                        key={'alt' + a.id + altIdx}>
                                        <img src={imgMode === 'fie' && altLevelsForThisTemplate ? `${URL.laravelBase}alt-images?alt_template_id=${altLevelsForThisTemplate.alternative_template_id}&product_id=${productId}&level=${a.level}&nocache=0` : a.url} width="60" />
                                    </GridCell>
                                })}
                            </Grid>
                        </GridCell>
                    }

                    <GridCell className={'next-link'}>
                        {!isTheLast &&
                            <Button
                                secondary={true}
                                type={'void'}
                                color={Theme.blue}
                                onClick={() => this.props.updateModal(1)}>{idx > 8 ?
                                    <Icon type={'angle-double-right'} size={navIconSize} color={Theme.blue} /> :
                                    <Icon type={'angle-right'} size={navIconSize} />
                                }</Button>
                        }
                    </GridCell>

                    <GridCell col={'1/-1'}>
                        {viewTable !== 'watermarks' && !isRemoveWatermark && !isRemoveBackground &&
                            <StyledMiddleColumnGrid cols={`repeat(${canEdit ? 6 : 5}, 1fr)`}>
                                {canEdit &&
                                    <GridCell className='clickable'>
                                        <div onClick={() => this.setState({ editMode: true })}>
                                            <Icon type={'edit-light'} color={Theme.blue} title={trans("edit")} size={20} />
                                        </div>
                                    </GridCell>
                                }
                                {imageOrAltUrl &&
                                    <GridCell className='clickable'>
                                        <div onClick={() => Mergado.openWindow(imageOrAltUrl)}>
                                            <Icon type={'file-image-o'} color={Theme.blue} title={trans("link_image_url")} size={20} />
                                        </div>
                                    </GridCell>
                                }
                                {previewUrl &&
                                    <GridCell className='clickable'>
                                        <div onClick={() => Mergado.openWindow(previewUrl)}>
                                            <Icon type={'feedimageeditor'} title={trans("link_fie")} size={20} />
                                        </div>
                                    </GridCell>
                                }
                                {mergadoProductUrl &&
                                    <GridCell className='clickable'>
                                        <div onClick={() => Mergado.openWindow(mergadoProductUrl)}>
                                            <Icon type={'mergado'} title={trans("link_mergado")} size={20} />
                                        </div>
                                    </GridCell>
                                }
                                {productUrl &&
                                    <GridCell className='clickable'>
                                        <div onClick={() => Mergado.openWindow(productUrl)}>
                                            <Icon type={'shopping-basket'} color={DarkGrayColor} title={trans("link_eshop")} size={20} />
                                        </div>
                                    </GridCell>
                                }
                                <GridCell className='item-id' style={{ whiteSpace: 'nowrap' }}>
                                    <Icon type={'tag'} text={firstItemId || itemId} title={"ITEM_ID"} />
                                </GridCell>
                            </StyledMiddleColumnGrid>
                        }
                    </GridCell>
                </StyledModalGrid>
            </ImagePreviewWrapper>
        )
    }
}


const StyledMiddleColumnGrid = css(Grid)({
    justifyContent: 'center',
    paddingBottom: '20px',
    ' .image-wrapper': {
        textAlign: 'center',
        verticalAlign: 'middle',
        alignSelf: 'center',
    },
})

const StyledModalGrid = css(Grid)({
    alignSelf: 'center',
    ' .title': {
        padding: '4px 0 10px 0',
        color: '#3a3a3a',
    },
    ' .alt-images': {
        paddingLeft: '10px',
    },
    ' .alt-images-gridcell': {
        cursor: 'pointer',
    },
    ' .alt-image-active': {
        border: `1px solid ${Theme.steelblue}`,
    },
    ' .image-div': {
        alignContent: 'center',
        ' img': {
            border: '1px solid #ccc',
            boxShadow: "0px 2px 5px 0 rgba(0,0,0,0.35)",
        },
    },
    ' .small-div': {
        height: 'calc(100vh - 200px)',
        ' img': {
            maxHeight: 'calc(100vh - 210px)',
        },
    },
    ' .big-div': {
        overflow: 'auto',
        ' img': {
            maxHeight: 'calc(100vh - 310px)',
        },
    },
    ' .item-id': {
        color: '#3a3a3a',
    },
})


function mapStateToProps(state) {
    return {
        settingsForm: selectFormValues(state, 'settingsForm'),
        gradients: state.gradients,
    }
}

export default connect(mapStateToProps, {
    setGradientsToStore,
})(ProductModalWrapper)
